import React from "react"
import {Box, Skeleton, Stack} from "@mui/material";

const ServiceDetailPlaceholder = () => {

    return <Stack
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        spacing={1}
    >
        <Skeleton width={700} height={400}/>
        <Box sx={{paddingTop: '81px'}}>
            <Stack
                sx={ {marginBottom: 2} }
                direction="row"
                spacing={2}
            >
                <Skeleton width={70} height={40}/>
                <Skeleton width={70} height={40}/>
                <Skeleton width={70} height={40}/>
            </Stack>
            <Skeleton width={207} height={28} />
            <Skeleton width={700} height={28} />
            <Skeleton width={700} height={28} />
            <Skeleton width={407} height={48} sx={ {marginTop: "67px"} } />
        </Box>
    </Stack>
}

export default ServiceDetailPlaceholder